import React from 'react';

export default function SummarySlide({ ideas, ideasByCategory, quickWins }) {
    const categoriesWithIdeas = ideasByCategory.filter(cat => cat.ideas?.length > 0).length;

    return (
        <div className="h-full w-full flex flex-col items-center justify-center bg-[#1a1a1a] text-white p-8 relative">
            {/* Logo */}
            <div className="absolute top-8 left-8">
                <img
                    src="/images/opificioai-logo-white.png"
                    alt="OpificioAI"
                    className="h-8 md:h-10 w-auto opacity-80"
                />
            </div>

            <div className="text-center max-w-4xl">
                <h1 className="text-5xl md:text-7xl font-bold mb-8">
                    Grazie
                </h1>

                <p className="text-xl md:text-2xl text-white/60 mb-16">
                    Riepilogo dell&apos;analisi
                </p>

                {/* Stats Grid */}
                <div className="grid grid-cols-3 gap-8 mb-16">
                    <div className="bg-white/10 rounded-2xl p-6">
                        <div className="text-4xl font-bold mb-2">
                            {ideas.length}
                        </div>
                        <div className="text-sm text-white/50">
                            {ideas.length === 1 ? 'Idea' : 'Idee'} Totali
                        </div>
                    </div>

                    <div className="bg-white/10 rounded-2xl p-6">
                        <div className="text-4xl font-bold mb-2">
                            {categoriesWithIdeas}
                        </div>
                        <div className="text-sm text-white/50">
                            {categoriesWithIdeas === 1 ? 'Area' : 'Aree'} Coinvolte
                        </div>
                    </div>

                    <div className="bg-white/10 rounded-2xl p-6">
                        <div className="text-4xl font-bold text-amber-400 mb-2">
                            {quickWins.length}
                        </div>
                        <div className="text-sm text-white/50">
                            Quick Wins
                        </div>
                    </div>
                </div>

                {/* Branding */}
                <div className="mt-16">
                    <img
                        src="/images/opificioai-logo-white.png"
                        alt="OpificioAI"
                        className="h-10 md:h-12 w-auto mx-auto opacity-40"
                    />
                    <div className="text-sm text-white/30 mt-2 flex flex-col">
                        <a href="tel:+39042972134" target="_blank" rel="noopener noreferrer" className="underline mb-2">0429 72134</a>
                        <a href="mailto:info@opificio.ai" target="_blank" rel="noopener noreferrer" className="underline mb-2">info@opificio.ai</a>
                        <a href="https://maps.app.goo.gl/Za7uD58uzecFjDEJ8" target="_blank" rel="noopener noreferrer" className="underline">Via Roma, 13 - 35043 Monselice (PD) - Italia</a>
                    </div>
                </div>
            </div>
        </div>
    );
}
